module.exports = __webpack_public_path__ + "img/left_1.f6b4235d.png";